var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xbd-tabs"},[_vm._l((_vm.tabs),function(item){return _c('div',{directives:[{name:"permission",rawName:"v-permission",value:(item.permissions),expression:"item.permissions"}],key:item.value,ref:`tab-${item.value}`,refInFor:true,staticClass:"xbd-tabs__tab",class:{
			active: _vm.value === item.value,
			disabled: item.disabled
		},on:{"click":function($event){return _vm.handleTabClick(item)}}},[(!_vm.hasTabSlot)?[_vm._v(_vm._s(item.label))]:_vm._t("default",null,{"tab":item})],2)}),_c('div',{staticClass:"xbd-tabs__bar",style:({
			width: `${_vm.barWidth}px`,
			transform: `translateX(${_vm.barOffsetLeft}px)`
		})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }